(function(){
    'use strict';

    angular.module('elogbooks.user.jobs', []);
})();
